// extracted by mini-css-extract-plugin
module.exports = {"root":"hero_root__2lglv","heading":"hero_heading__92tZN","lede":"hero_lede__UdRHF","button":"hero_button__2p_zY"};